import { Sparkles } from 'lucide-react'
import { defineModule } from '@/shell/module-system'
import { CarlaPage } from './pages/CarlaPage'

/**
 * CARLA — AI coworker. Available to every role that rbac.py marks
 * `can_chat: True` (admin, sales, operations, regulatory, finance),
 * restoring the legacy "CARLA for everyone" pattern that was scoped
 * admin-only at M11 cutover. Viewer is excluded because rbac.py marks
 * viewer `can_chat: False` — showing the page to a role that can't
 * send a message is worse UX than hiding it. Routes POST
 * /api/chat/stream with SSE streaming for real-time assistant replies;
 * conversation list/history via /api/chat/conversations.
 *
 * Write-capability tools (e.g. update_product) remain gated server-side
 * via the `admin=true` request flag, which the ops frontend sends only
 * when the authenticated user has the `admin` permission. Non-admin
 * roles see CARLA but cannot invoke admin-tagged tools — the server
 * hides those from the agent catalog. The Odoo Owl widget and this
 * page coexist — Odoo-embedded users keep their in-Odoo CARLA.
 */
export default defineModule({
  id: 'carla',
  name: 'CARLA',
  shortName: 'CARLA',
  icon: Sparkles,
  navSection: 'admin',
  // Sprint 13a (2026-04-26): retconned from 80 to 10 so CARLA leads
  // the Admin section above Action History (20) and Settings (90).
  navOrder: 10,
  urlNamespace: '/carla',
  routes: [{ path: '/', element: CarlaPage, label: 'CARLA' }],
  permissions: ['admin', 'sales', 'operations', 'operations_logistics', 'purchasing', 'regulatory', 'finance'],
  densityDefault: 'comfortable',
  mobileStrategy: 'responsive',

  keyboardShortcut: 'g z',

  commandPaletteEntries: [
    {
      label: 'Go to CARLA',
      keywords: ['carla', 'chat', 'assistant', 'ai', 'coworker'],
      path: '/',
      group: 'modules',
      shortcut: 'g z',
    },
  ],
})
